import React from "react";
import { bool, elementType, node, string } from "prop-types";
import { Zoom, Tooltip, Box } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { tooltipStyles } from "../component-styles";
import googleAnalytics from "shared/analytics";
import { useLocation } from "react-router";

const TooltipContent = React.forwardRef(function TooltipContent(
  { content, icon = null, controlHeight = true, contentReversed = false, ...rest },
  ref,
) {
  const Icon = icon || InfoIcon;
  return (
    // `rest` is an intentional open-ended passthrough (e.g. onClick, aria-*)
    // for any caller-supplied trigger props (see bindTrigger() usage
    // elsewhere) that should flow straight through to the underlying Box.
    <Box
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      ref={ref}
      sx={[
        controlHeight ? tooltipStyles.root : tooltipStyles.rootNoMinHeight,
        contentReversed && tooltipStyles.reversed,
      ]}
    >
      {content}
      <Icon sx={[tooltipStyles.icon, contentReversed && tooltipStyles.iconLeft]} />
    </Box>
  );
});

TooltipContent.propTypes = {
  content: node.isRequired,
  icon: elementType,
  controlHeight: bool,
  contentReversed: bool,
};

const CustomTooltip = ({
  content,
  title = "",
  id = "",
  controlHeight = true,
  contentReversed = false,
  icon = null,
}) => {
  const location = useLocation();
  return (
    <Tooltip
      title={title || content}
      aria-label={`tooltip for ${id}`}
      placement="top"
      onOpen={() => {
        let _content = title && typeof title === "string" ? title : "";
        if (!_content) {
          _content =
            content &&
            content.props &&
            content.props.children &&
            typeof content.props.children === "string"
              ? content.props.children
              : content.props.children.props &&
                  content.props.children.props.children &&
                  typeof content.props.children.props.children === "string"
                ? content.props.children.props.children
                : "Content unavailable - the content may be an HTML element";
        }
        googleAnalytics.trackTooltipOpen({
          label: id || location.pathname,
          content: _content,
        });
      }}
      slots={{
        transition: Zoom,
      }}
    >
      <TooltipContent
        content={content}
        icon={icon}
        controlHeight={controlHeight}
        contentReversed={contentReversed}
      />
    </Tooltip>
  );
};

CustomTooltip.propTypes = {
  content: node.isRequired,
  title: node,
  id: string,
  controlHeight: bool,
  contentReversed: bool,
  icon: elementType,
};

export default CustomTooltip;
